import { theme } from "../../theme";
export const emptyScreenStyles = {
  emptyScreen: {
    display: "flex",
    alignItems: "center",
    height: "100%",
    justifyContent: "center",
    "& .iconStyle": {
      mb: 2,
      background:
        "linear-gradient(139.4deg, rgba(123,123,123, 0.2) 4.09%, rgba(123,123,123, 0) 87.78%)",
      height: "150px",
      width: "150px",
      borderRadius: "50%",
      mx: "auto",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
  },
} as const;
